import {getWindowWidth, isSmallScreen} from "../../blinkpay/UtilsLib";
import {MIN_SUPPORTED_WINDOW_WIDTH} from "../Constants";

export function getSandboxProperties() {
    return (
        "allow-popups allow-scripts allow-same-origin allow-popups-to-escape-sandbox " +
        " allow-top-navigation-by-user-activation allow-forms"
    );
}

export function NOOP_FUNCTION() {}

export function getClientIdFromCurrentScriptUrl() {
    try {
        return (new URL(document.currentScript.src)).searchParams.get("clientId");
    } catch {
        return null;
    }
}

export function formatAgoMessage(timestamp) {
    const duration = Date.now() - timestamp;
    const msToMinute = 60 * 1000;
    const msToHour = msToMinute * 60;
    const msToDay = msToHour * 24;
    const days = parseInt(duration / msToDay, 10);
    const hours = parseInt((duration % msToDay) / msToHour, 10);
    const minutes = parseInt((duration % msToHour) / msToMinute, 10);
    let result = `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
    if (days || hours) {
        result = `${hours} hour${hours === 1 ? "" : "s"}, ` + result;
        if (days) {
            result = `${days} day${days === 1 ? "" : "s"}, ` + result;
        }
    }
    return result;
}

export function delayThrottled(func, ms) {
    let timeoutId = null;
    return () => {
        if (timeoutId == null) {
            timeoutId = setTimeout(() => {
                func();
                timeoutId = null;
            }, ms);
        }
    };
}

export function delayDebounced(func, ms) {
    let timeoutId = null;
    return () => {
        if (timeoutId != null) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => {
            func();
            timeoutId = null;
        }, ms);
    };
}

// Checks if the browser has support for passive event listeners.
// When an event listener is set as passive, it indicates that the callback will not cancel
// the event by invoking preventDefault().
let supportsPassiveEventsCached = null;
export function supportsPassiveEvents() {
    // Check if the variable has been previously initialized
    if (supportsPassiveEventsCached == null) {
        try {
            window.addEventListener("test", null, Object.defineProperty({}, "passive", {
                get: () => {
                    supportsPassiveEventsCached = true;
                    return null;
                }})
            );
            // eslint-disable-next-line no-empty
        } catch (e) {
        }
    }

    return supportsPassiveEventsCached;
}

export function preventScrollPropagation(node, isExpanded) {
    let insideNode = false;
    let scrollX = null;
    let scrollY = null;
    const onMouseEnter = () => {
        if (!isExpanded()) {
            insideNode = false;
            return;
        }
        insideNode = true;
        scrollX = window.scrollX;
        scrollY = window.scrollY;
    };
    const onMouseLeave = () => {
        insideNode = false;
    };
    const timestampMaximumGap = 50;
    let lastTimestamp = -timestampMaximumGap;
    const onScroll = event => {
        if (!isExpanded()) {
            insideNode = false;
            return;
        }
        if (insideNode && event.timestamp - lastTimestamp < timestampMaximumGap) {
            window.scrollTo(scrollX, scrollY);
        }
        lastTimestamp = event.timestamp;
    };

    node.addEventListener("mouseenter", onMouseEnter);
    node.addEventListener("mouseleave", onMouseLeave);

    node.addEventListener("touchstart", onMouseEnter);
    node.addEventListener("touchend", onMouseLeave);

    const scrollEventOptions = supportsPassiveEvents() ? {passive : false} : false;

    document.addEventListener("scroll", onScroll, scrollEventOptions);
    document.addEventListener("touchmove", onScroll, scrollEventOptions);
}

export function getWidgetRightPosition() {
    return isSmallScreen() ? 10 : 24;
}

export function filterObjectKeys(obj, keys) {
    const newObj = {};
    for (const key of Object.keys(obj)) {
        if (keys.indexOf(key) >= 0) {
            newObj[key] = obj[key];
        }
    }
    return newObj;
}

export function asArray(objOrArray) {
    return Array.isArray(objOrArray) ? objOrArray : [objOrArray];
}

export function computeScreenScaleFactor() {
    if (getWindowWidth() < MIN_SUPPORTED_WINDOW_WIDTH) {
        return (MIN_SUPPORTED_WINDOW_WIDTH / getWindowWidth());
    }
    return 1;
}
